import { TExternalLink } from "./TExternalLink";

export enum EBrandName {
  domcura = "domcura",
  nordias = "nordias",
  innoas = "innoas",
  nordvers = "nordvers",
  default = "default"
};

export type TInfoBox = {
  brand: EBrandName;
  items: TExternalLink[];
}